'use client';

import React from 'react';

const SetHeadersOnClient: React.FC<{ headers: Record<string, string | null> }> = ({ headers }) => {
  if (headers && globalThis.window) {
    globalThis.window.__FORWARDED_HEADERS__ = headers;
  }

  return null;
};

export default SetHeadersOnClient;
